// WARNING: Automatically generated code. Any changes to this file will be overwritten.
import { arrayToPickyDict, Dict } from '@nk/utils-lib';
import { DimContainer, DimFlagContainer } from '../types/app-dim-types';
import { AccountsTypeEntity, AppFeatureEntity, AppFeaturePackageEntity, AppInterfaceModeEntity, AppRoleEntity, AttributeTypeEntity, CompanyAffiliationTypeEntity, CompanyCollateralTypeEntity, CompanyDescriptionTypeEntity, CompanyFlagTypeEntity, CompanyHierarchyTypeEntity, CompanyLocationTypeEntity, CompanyMeasureTypeEntity, CompanyShareOwnershipTypeEntity, DataSourceCategoryEntity, DataSourceEntity, GenderEntity, ModelTypeEntity, SensitiveDataTypeEntity } from './app-base-app';

// app.app_feature.app_feature_key
export enum AppFeatureKey {
  accounts_unlimited_history = 'accounts_unlimited_history',
  adverse_event = 'adverse_event',
  analysis_api = 'analysis_api',
  auditor_notes_unlimited_history = 'auditor_notes_unlimited_history',
  bank_account_prevalidation = 'bank_account_prevalidation',
  bankruptcy_quarantine = 'bankruptcy_quarantine',
  base = 'base',
  beneficial_ownership = 'beneficial_ownership',
  collateral = 'collateral',
  company_browser_media_mention_search = 'company_browser_media_mention_search',
  company_browser_unrestricted = 'company_browser_unrestricted',
  company_review = 'company_review',
  company_risk_score = 'company_risk_score',
  corpia_industry_benchmark_report = 'corpia_industry_benchmark_report',
  creditsafe_company_report = 'creditsafe_company_report',
  custom_company_report = 'custom_company_report',
  customer_santander_flags = 'customer_santander_flags',
  danish_data = 'danish_data',
  data_explorer = 'data_explorer',
  datasets_api = 'datasets_api',
  enterprise_value = 'enterprise_value',
  events_news = 'events_news',
  events_news_digital = 'events_news_digital',
  events_news_print = 'events_news_print',
  experimental_company_flags = 'experimental_company_flags',
  experimental_person_flags = 'experimental_person_flags',
  extended_company_flags = 'extended_company_flags',
  extended_person_flags = 'extended_person_flags',
  finnish_data = 'finnish_data',
  fraud_risk_score = 'fraud_risk_score',
  historical_ownership = 'historical_ownership',
  historical_roles = 'historical_roles',
  indicator_flags = 'indicator_flags',
  network_risk_score = 'network_risk_score',
  norwegian_data = 'norwegian_data',
  norwegian_mortgaged_movable_property_data = 'norwegian_mortgaged_movable_property_data',
  norwegian_property_data = 'norwegian_property_data',
  payment_remark = 'payment_remark',
  payment_remark_company_overview = 'payment_remark_company_overview',
  risk_unlimited_history = 'risk_unlimited_history',
  roles_unlimited_history = 'roles_unlimited_history',
  screening = 'screening',
  swedish_data = 'swedish_data',
}

// app.app_feature.app_feature_key
export class AppFeatureDims implements DimContainer<AppFeatureKey>, DimFlagContainer {
  public flags:
    | {
        accounts_unlimited_history: boolean;
        adverse_event: boolean;
        analysis_api: boolean;
        auditor_notes_unlimited_history: boolean;
        bank_account_prevalidation: boolean;
        bankruptcy_quarantine: boolean;
        base: boolean;
        beneficial_ownership: boolean;
        collateral: boolean;
        company_browser_media_mention_search: boolean;
        company_browser_unrestricted: boolean;
        company_review: boolean;
        company_risk_score: boolean;
        corpia_industry_benchmark_report: boolean;
        creditsafe_company_report: boolean;
        custom_company_report: boolean;
        customer_santander_flags: boolean;
        danish_data: boolean;
        data_explorer: boolean;
        datasets_api: boolean;
        enterprise_value: boolean;
        events_news: boolean;
        events_news_digital: boolean;
        events_news_print: boolean;
        experimental_company_flags: boolean;
        experimental_person_flags: boolean;
        extended_company_flags: boolean;
        extended_person_flags: boolean;
        finnish_data: boolean;
        fraud_risk_score: boolean;
        historical_ownership: boolean;
        historical_roles: boolean;
        indicator_flags: boolean;
        network_risk_score: boolean;
        norwegian_data: boolean;
        norwegian_mortgaged_movable_property_data: boolean;
        norwegian_property_data: boolean;
        payment_remark: boolean;
        payment_remark_company_overview: boolean;
        risk_unlimited_history: boolean;
        roles_unlimited_history: boolean;
        screening: boolean;
        swedish_data: boolean;
      }
    | Dict<boolean>;
  public dims: AppFeatureEntity[];
  public keys: AppFeatureKey[];

  constructor(dims: AppFeatureEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.app_feature_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.app_feature_key as AppFeatureKey);
  }
}

// app.app_feature_package.app_feature_package_key
export enum AppFeaturePackageKey {
  adverse_event = 'adverse_event',
  analysis_api = 'analysis_api',
  app_basic = 'app_basic',
  app_enterprise = 'app_enterprise',
  app_pro = 'app_pro',
  app_pro_news = 'app_pro_news',
  app_trial = 'app_trial',
  bank_account_prevalidation = 'bank_account_prevalidation',
  beta = 'beta',
  corpia_reports = 'corpia_reports',
  custom_company_report = 'custom_company_report',
  customer_santander_flags = 'customer_santander_flags',
  datasets_api = 'datasets_api',
  eika_base = 'eika_base',
  experimental_flags = 'experimental_flags',
  fraud_risk_score = 'fraud_risk_score',
  historical_ownership = 'historical_ownership',
  indicator_flags = 'indicator_flags',
  network_risk_score = 'network_risk_score',
  nordic_beta = 'nordic_beta',
  norwegian_mortgaged_movable_property_data = 'norwegian_mortgaged_movable_property_data',
  norwegian_property_data = 'norwegian_property_data',
  payment_remark = 'payment_remark',
  payment_remark_company_overview = 'payment_remark_company_overview',
  screening_beta = 'screening_beta',
}

// app.app_feature_package.app_feature_package_key
export class AppFeaturePackageDims implements DimContainer<AppFeaturePackageKey>, DimFlagContainer {
  public flags:
    | {
        adverse_event: boolean;
        analysis_api: boolean;
        app_basic: boolean;
        app_enterprise: boolean;
        app_pro: boolean;
        app_pro_news: boolean;
        app_trial: boolean;
        bank_account_prevalidation: boolean;
        beta: boolean;
        corpia_reports: boolean;
        custom_company_report: boolean;
        customer_santander_flags: boolean;
        datasets_api: boolean;
        eika_base: boolean;
        experimental_flags: boolean;
        fraud_risk_score: boolean;
        indicator_flags: boolean;
        network_risk_score: boolean;
        nordic_beta: boolean;
        norwegian_mortgaged_movable_property_data: boolean;
        norwegian_property_data: boolean;
        payment_remark: boolean;
        payment_remark_company_overview: boolean;
        screening_beta: boolean;
      }
    | Dict<boolean>;
  public dims: AppFeaturePackageEntity[];
  public keys: AppFeaturePackageKey[];

  constructor(dims: AppFeaturePackageEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.app_feature_package_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.app_feature_package_key as AppFeaturePackageKey);
  }
}

// app.app_role.app_role_key
export enum AppRoleKey {
  adverse_event = 'adverse_event',
  aml = 'aml',
  api_client_admin = 'api_client_admin',
  bank_account_prevalidation = 'bank_account_prevalidation',
  credit_check = 'credit_check',
  customer_admin = 'customer_admin',
  customer_santander_flags = 'customer_santander_flags',
  experimental_flags = 'experimental_flags',
  fraud_risk_score = 'fraud_risk_score',
  indicator_flags = 'indicator_flags',
  network_risk_score = 'network_risk_score',
  norwegian_mortgaged_movable_property_data = 'norwegian_mortgaged_movable_property_data',
  norwegian_property_data = 'norwegian_property_data',
  person_national_identification = 'person_national_identification',
  superuser = 'superuser',
}

// app.app_role.app_role_key
export class AppRoleDims implements DimContainer<AppRoleKey>, DimFlagContainer {
  public flags:
    | {
        adverse_event: boolean;
        aml: boolean;
        api_client_admin: boolean;
        bank_account_prevalidation: boolean;
        credit_check: boolean;
        customer_admin: boolean;
        customer_santander_flags: boolean;
        experimental_flags: boolean;
        fraud_risk_score: boolean;
        indicator_flags: boolean;
        network_risk_score: boolean;
        norwegian_mortgaged_movable_property_data: boolean;
        norwegian_property_data: boolean;
        person_national_identification: boolean;
        superuser: boolean;
      }
    | Dict<boolean>;
  public dims: AppRoleEntity[];
  public keys: AppRoleKey[];

  constructor(dims: AppRoleEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.app_role_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.app_role_key as AppRoleKey);
  }
}

// app.app_interface_mode.app_interface_mode_key
export enum AppInterfaceModeKey {
  compliance = 'compliance',
  credit_risk = 'credit_risk',
  general = 'general',
  investing = 'investing',
  sales = 'sales',
}

// app.app_interface_mode.app_interface_mode_key
export class AppInterfaceModeDims implements DimContainer<AppInterfaceModeKey>, DimFlagContainer {
  public flags:
    | {
        compliance: boolean;
        credit_risk: boolean;
        general: boolean;
        investing: boolean;
        sales: boolean;
      }
    | Dict<boolean>;
  public dims: AppInterfaceModeEntity[];
  public keys: AppInterfaceModeKey[];

  constructor(dims: AppInterfaceModeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.app_interface_mode_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.app_interface_mode_key as AppInterfaceModeKey);
  }
}

// app.accounts_type.accounts_type_key
export enum AccountsTypeKey {
  annual_company_accounts = 'annual_company_accounts',
  annual_company_accounts_converted_to_eur = 'annual_company_accounts_converted_to_eur',
  annual_corporate_group_accounts = 'annual_corporate_group_accounts',
  annual_corporate_group_accounts_converted_to_eur = 'annual_corporate_group_accounts_converted_to_eur',
}

// app.accounts_type.accounts_type_key
export class AccountsTypeDims implements DimContainer<AccountsTypeKey>, DimFlagContainer {
  public flags:
    | {
        annual_company_accounts: boolean;
        annual_company_accounts_converted_to_eur: boolean;
        annual_corporate_group_accounts: boolean;
        annual_corporate_group_accounts_converted_to_eur: boolean;
      }
    | Dict<boolean>;
  public dims: AccountsTypeEntity[];
  public keys: AccountsTypeKey[];

  constructor(dims: AccountsTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.accounts_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.accounts_type_key as AccountsTypeKey);
  }
}

// app.attribute_type.attribute_type_key
export enum AttributeTypeKey {
  company_age = 'company_age',
  company_relationship_start = 'company_relationship_start',
  company_risk_level = 'company_risk_level',
  company_risk_score = 'company_risk_score',
  company_size = 'company_size',
  exposure = 'exposure',
  foreign_home_office_address = 'foreign_home_office_address',
  industry_code = 'industry_code',
  ship_ownership = 'ship_ownership',
}

// app.attribute_type.attribute_type_key
export class AttributeTypeDims implements DimContainer<AttributeTypeKey>, DimFlagContainer {
  public flags:
    | {
        company_age: boolean;
        company_relationship_start: boolean;
        company_risk_level: boolean;
        company_risk_score: boolean;
        company_size: boolean;
        exposure: boolean;
        foreign_home_office_address: boolean;
        industry_code: boolean;
        ship_ownership: boolean;
      }
    | Dict<boolean>;
  public dims: AttributeTypeEntity[];
  public keys: AttributeTypeKey[];

  constructor(dims: AttributeTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.attribute_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.attribute_type_key as AttributeTypeKey);
  }
}

// app.company_description_type.company_description_type_key
export enum CompanyDescriptionTypeKey {
  asiakastieto_purpose = 'asiakastieto_purpose',
  bolagsverket_official_purpose = 'bolagsverket_official_purpose',
  brreg_official_purpose = 'brreg_official_purpose',
  cvr_official_purpose = 'cvr_official_purpose',
}

// app.company_description_type.company_description_type_key
export class CompanyDescriptionTypeDims implements DimContainer<CompanyDescriptionTypeKey>, DimFlagContainer {
  public flags:
    | {
        asiakastieto_purpose: boolean;
        bolagsverket_official_purpose: boolean;
        brreg_official_purpose: boolean;
        cvr_official_purpose: boolean;
      }
    | Dict<boolean>;
  public dims: CompanyDescriptionTypeEntity[];
  public keys: CompanyDescriptionTypeKey[];

  constructor(dims: CompanyDescriptionTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.company_description_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.company_description_type_key as CompanyDescriptionTypeKey);
  }
}

// app.company_hierarchy_type.company_hierarchy_type_key
export enum CompanyHierarchyTypeKey {
  group_hierarchy = 'group_hierarchy',
}

// app.company_hierarchy_type.company_hierarchy_type_key
export class CompanyHierarchyTypeDims implements DimContainer<CompanyHierarchyTypeKey>, DimFlagContainer {
  public flags:
    | {
        group_hierarchy: boolean;
      }
    | Dict<boolean>;
  public dims: CompanyHierarchyTypeEntity[];
  public keys: CompanyHierarchyTypeKey[];

  constructor(dims: CompanyHierarchyTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.company_hierarchy_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.company_hierarchy_type_key as CompanyHierarchyTypeKey);
  }
}

// app.company_location_type.company_location_type_key
export enum CompanyLocationTypeKey {
  business_address = 'business_address',
  postal_address = 'postal_address',
}

// app.company_location_type.company_location_type_key
export class CompanyLocationTypeDims implements DimContainer<CompanyLocationTypeKey>, DimFlagContainer {
  public flags:
    | {
        business_address: boolean;
        postal_address: boolean;
      }
    | Dict<boolean>;
  public dims: CompanyLocationTypeEntity[];
  public keys: CompanyLocationTypeKey[];

  constructor(dims: CompanyLocationTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.company_location_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.company_location_type_key as CompanyLocationTypeKey);
  }
}

// app.company_share_ownership_type.company_share_ownership_type_key
export enum CompanyShareOwnershipTypeKey {
  corporate_group = 'corporate_group',
  direct_ownership = 'direct_ownership',
  indirect_ownership = 'indirect_ownership',
  known_beneficial_ownership = 'known_beneficial_ownership',
  possible_beneficial_ownership = 'possible_beneficial_ownership',
  ultimate_ownership = 'ultimate_ownership',
}

// app.company_share_ownership_type.company_share_ownership_type_key
export class CompanyShareOwnershipTypeDims implements DimContainer<CompanyShareOwnershipTypeKey>, DimFlagContainer {
  public flags:
    | {
        corporate_group: boolean;
        direct_ownership: boolean;
        indirect_ownership: boolean;
        known_beneficial_ownership: boolean;
        possible_beneficial_ownership: boolean;
        ultimate_ownership: boolean;
      }
    | Dict<boolean>;
  public dims: CompanyShareOwnershipTypeEntity[];
  public keys: CompanyShareOwnershipTypeKey[];

  constructor(dims: CompanyShareOwnershipTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.company_share_ownership_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.company_share_ownership_type_key as CompanyShareOwnershipTypeKey);
  }
}

// app.company_affiliation_type.company_affiliation_type_key
export enum CompanyAffiliationTypeKey {
  accountant = 'accountant',
  actuary = 'actuary',
  auditor = 'auditor',
  business_manager = 'business_manager',
  client = 'client',
  cosupplier = 'cosupplier',
  deltaker_med_solidarisk_ansvar = 'deltaker_med_solidarisk_ansvar',
  deltaker_proratisk_ansvar = 'deltaker_proratisk_ansvar',
  demerger_aborted_aquirer = 'demerger_aborted_aquirer',
  demerger_aborted_transferor = 'demerger_aborted_transferor',
  demerger_decision_aquirer = 'demerger_decision_aquirer',
  demerger_decision_transferor = 'demerger_decision_transferor',
  demerger_execution_aquirer = 'demerger_execution_aquirer',
  demerger_execution_transferor = 'demerger_execution_transferor',
  demerger_planned_aquirer = 'demerger_planned_aquirer',
  demerger_planned_transferor = 'demerger_planned_transferor',
  demerger_transferor_deleted = 'demerger_transferor_deleted',
  deputy_auditor = 'deputy_auditor',
  deputy_lay_auditor = 'deputy_lay_auditor',
  eierkomune = 'eierkomune',
  komplementar = 'komplementar',
  lawyer = 'lawyer',
  lay_auditor = 'lay_auditor',
  managing_shipowner = 'managing_shipowner',
  merger_aborted_aquirer = 'merger_aborted_aquirer',
  merger_aborted_transferor = 'merger_aborted_transferor',
  merger_decision_aquirer = 'merger_decision_aquirer',
  merger_decision_transferor = 'merger_decision_transferor',
  merger_execution_aquirer = 'merger_execution_aquirer',
  merger_execution_transferor = 'merger_execution_transferor',
  merger_plan_aborted_aquirer = 'merger_plan_aborted_aquirer',
  merger_plan_aborted_transferor = 'merger_plan_aborted_transferor',
  merger_planned_aquirer = 'merger_planned_aquirer',
  merger_planned_transferor = 'merger_planned_transferor',
  merger_transferor_deleted = 'merger_transferor_deleted',
  norwegian_representative_foreign_unit = 'norwegian_representative_foreign_unit',
  primary_auditor = 'primary_auditor',
  subsupplier = 'subsupplier',
}

// app.company_affiliation_type.company_affiliation_type_key
export class CompanyAffiliationTypeDims implements DimContainer<CompanyAffiliationTypeKey>, DimFlagContainer {
  public flags:
    | {
        accountant: boolean;
        actuary: boolean;
        auditor: boolean;
        business_manager: boolean;
        client: boolean;
        cosupplier: boolean;
        deltaker_med_solidarisk_ansvar: boolean;
        deltaker_proratisk_ansvar: boolean;
        demerger_aborted_aquirer: boolean;
        demerger_aborted_transferor: boolean;
        demerger_decision_aquirer: boolean;
        demerger_decision_transferor: boolean;
        demerger_execution_aquirer: boolean;
        demerger_execution_transferor: boolean;
        demerger_planned_aquirer: boolean;
        demerger_planned_transferor: boolean;
        demerger_transferor_deleted: boolean;
        deputy_auditor: boolean;
        deputy_lay_auditor: boolean;
        eierkomune: boolean;
        komplementar: boolean;
        lawyer: boolean;
        lay_auditor: boolean;
        managing_shipowner: boolean;
        merger_aborted_aquirer: boolean;
        merger_aborted_transferor: boolean;
        merger_decision_aquirer: boolean;
        merger_decision_transferor: boolean;
        merger_execution_aquirer: boolean;
        merger_execution_transferor: boolean;
        merger_plan_aborted_aquirer: boolean;
        merger_plan_aborted_transferor: boolean;
        merger_planned_aquirer: boolean;
        merger_planned_transferor: boolean;
        merger_transferor_deleted: boolean;
        norwegian_representative_foreign_unit: boolean;
        primary_auditor: boolean;
        subsupplier: boolean;
      }
    | Dict<boolean>;
  public dims: CompanyAffiliationTypeEntity[];
  public keys: CompanyAffiliationTypeKey[];

  constructor(dims: CompanyAffiliationTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.company_affiliation_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.company_affiliation_type_key as CompanyAffiliationTypeKey);
  }
}

// app.model_type.model_type_key
export enum ModelTypeKey {
  company_event_risk_interesting = 'company_event_risk_interesting',
  company_event_risk_score = 'company_event_risk_score',
  company_event_sales_interesting = 'company_event_sales_interesting',
  company_event_sales_trigger = 'company_event_sales_trigger',
  company_risk_score = 'company_risk_score',
  person_aggregate_capital = 'person_aggregate_capital',
}

// app.model_type.model_type_key
export class ModelTypeDims implements DimContainer<ModelTypeKey>, DimFlagContainer {
  public flags:
    | {
        company_event_risk_interesting: boolean;
        company_event_risk_score: boolean;
        company_event_sales_interesting: boolean;
        company_event_sales_trigger: boolean;
        company_risk_score: boolean;
        person_aggregate_capital: boolean;
      }
    | Dict<boolean>;
  public dims: ModelTypeEntity[];
  public keys: ModelTypeKey[];

  constructor(dims: ModelTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.model_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.model_type_key as ModelTypeKey);
  }
}

// app.sensitive_data_type.sensitive_data_type_key
export enum SensitiveDataTypeKey {
  payment_remark = 'payment_remark',
  person_national_identification = 'person_national_identification',
}

// app.sensitive_data_type.sensitive_data_type_key
export class SensitiveDataTypeDims implements DimContainer<SensitiveDataTypeKey>, DimFlagContainer {
  public flags:
    | {
        payment_remark: boolean;
        person_national_identification: boolean;
      }
    | Dict<boolean>;
  public dims: SensitiveDataTypeEntity[];
  public keys: SensitiveDataTypeKey[];

  constructor(dims: SensitiveDataTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.sensitive_data_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.sensitive_data_type_key as SensitiveDataTypeKey);
  }
}

// app.gender.gender_key
export enum GenderKey {
  female = 'female',
  male = 'male',
  other = 'other',
}

// app.gender.gender_key
export class GenderDims implements DimContainer<GenderKey>, DimFlagContainer {
  public flags:
    | {
        female: boolean;
        male: boolean;
        other: boolean;
      }
    | Dict<boolean>;
  public dims: GenderEntity[];
  public keys: GenderKey[];

  constructor(dims: GenderEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.gender_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.gender_key as GenderKey);
  }
}

// app.data_source.data_source_key
export enum DataSourceKey {
  axactor_axactor_sftp = 'axactor^^^axactor^^^sftp',
  berammingslister = 'berammingslister',
  brreg = 'brreg',
  brreg_norwegian_movable_property_register_ftp = 'brreg^^^norwegian_movable_property_register^^^ftp',
  brreg_norwegian_movable_property_register_payment_remarks = 'brreg^^^norwegian_movable_property_register^^^payment_remarks',
  collateral = 'collateral',
  cvr_cvr_elasticsearch = 'cvr^^^cvr^^^elasticsearch',
  cvr_ownership_denmark_elasticsearch = 'cvr^^^ownership_denmark^^^elasticsearch',
  dk_cvr_registreringstidende_web = 'dk_cvr^^^registreringstidende^^^web',
  doffin = 'doffin',
  enin_enin_company_risk_score_database = 'enin^^^enin_company_risk_score^^^database',
  external_role_register = 'external_role_register',
  fsa_norway = 'fsa_norway',
  haveibeenpwned = 'haveibeenpwned',
  intrum_intrum_sftp = 'intrum^^^intrum^^^sftp',
  kartverket_geonorge_webshop = 'kartverket^^^geonorge^^^webshop',
  kredinor_kredinor_sftp = 'kredinor^^^kredinor^^^sftp',
  mbrain = 'mbrain',
  mbrain_digital_mbrain = 'mbrain_digital^^^mbrain',
  mbrain_print_mbrain = 'mbrain_print^^^mbrain',
  norwegian_mapping_authority_grunnboken_payment_remarks = 'norwegian_mapping_authority^^^grunnboken^^^payment_remarks',
  norwegian_mapping_authority_grunnboken_soap = 'norwegian_mapping_authority^^^grunnboken^^^soap',
  norwegian_mapping_authority_matrikkel_soap = 'norwegian_mapping_authority^^^matrikkel^^^soap',
  norwegian_maritime_authority_norwegian_ship_register_web = 'norwegian_maritime_authority^^^norwegian_ship_register^^^web',
  override = 'override',
  ownership_norway = 'ownership_norway',
  person_legacy = 'person_legacy',
  phr_phr_web = 'phr^^^phr^^^web',
  poit_bolagsverket_web = 'poit^^^bolagsverket^^^web',
  proff_registry = 'proff_registry',
  se_proff_ownership_sweden_api = 'se_proff^^^ownership_sweden^^^api',
  skatteetaten = 'skatteetaten',
  statstidende_statstidende_web = 'statstidende^^^statstidende^^^web',
  styrelsen_for_dataforsyning_og_infrastruktur_dataforsyningen_api = 'styrelsen_for_dataforsyning_og_infrastruktur^^^dataforsyningen^^^api',
  svea_svea_sftp = 'svea^^^svea^^^sftp',
  t_rank_t_rank_api = 't_rank^^^t_rank^^^api',
}

// app.data_source.data_source_key
export class DataSourceDims implements DimContainer<DataSourceKey>, DimFlagContainer {
  public flags:
    | {
        axactor_axactor_sftp: boolean;
        berammingslister: boolean;
        brreg: boolean;
        brreg_norwegian_movable_property_register_ftp: boolean;
        brreg_norwegian_movable_property_register_payment_remarks: boolean;
        collateral: boolean;
        cvr_cvr_elasticsearch: boolean;
        cvr_ownership_denmark_elasticsearch: boolean;
        dk_cvr_registreringstidende_web: boolean;
        doffin: boolean;
        enin_enin_company_risk_score_database: boolean;
        external_role_register: boolean;
        fsa_norway: boolean;
        haveibeenpwned: boolean;
        intrum_intrum_sftp: boolean;
        kartverket_geonorge_webshop: boolean;
        kredinor_kredinor_sftp: boolean;
        mbrain: boolean;
        mbrain_digital_mbrain: boolean;
        mbrain_print_mbrain: boolean;
        norwegian_mapping_authority_grunnboken_payment_remarks: boolean;
        norwegian_mapping_authority_grunnboken_soap: boolean;
        norwegian_mapping_authority_matrikkel_soap: boolean;
        norwegian_maritime_authority_norwegian_ship_register_web: boolean;
        override: boolean;
        ownership_norway: boolean;
        person_legacy: boolean;
        phr_phr_web: boolean;
        poit_bolagsverket_web: boolean;
        proff_registry: boolean;
        se_proff_ownership_sweden_api: boolean;
        skatteetaten: boolean;
        statstidende_statstidende_web: boolean;
        styrelsen_for_dataforsyning_og_infrastruktur_dataforsyningen_api: boolean;
        svea_svea_sftp: boolean;
        t_rank_t_rank_api: boolean;
      }
    | Dict<boolean>;
  public dims: DataSourceEntity[];
  public keys: DataSourceKey[];

  constructor(dims: DataSourceEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.data_source_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.data_source_key as DataSourceKey);
  }
}

// app.data_source_category.data_source_category_key
export enum DataSourceCategoryKey {
  country_dk = 'country^^^dk',
  country_fi = 'country^^^fi',
  country_no = 'country^^^no',
  country_se = 'country^^^se',
  event_announcement = 'event^^^announcement',
  event_collateral = 'event^^^collateral',
  event_company_event_risk_score = 'event^^^company_event_risk_score',
  event_compensation_scheme = 'event^^^compensation_scheme',
  event_court = 'event^^^court',
  event_news = 'event^^^news',
  event_ownership_changes = 'event^^^ownership_changes',
  event_payment_remark = 'event^^^payment_remark',
  event_procurements = 'event^^^procurements',
}

// app.data_source_category.data_source_category_key
export class DataSourceCategoryDims implements DimContainer<DataSourceCategoryKey>, DimFlagContainer {
  public flags:
    | {
        country_dk: boolean;
        country_fi: boolean;
        country_no: boolean;
        country_se: boolean;
        event_announcement: boolean;
        event_collateral: boolean;
        event_company_event_risk_score: boolean;
        event_compensation_scheme: boolean;
        event_court: boolean;
        event_news: boolean;
        event_ownership_changes: boolean;
        event_payment_remark: boolean;
        event_procurements: boolean;
      }
    | Dict<boolean>;
  public dims: DataSourceCategoryEntity[];
  public keys: DataSourceCategoryKey[];

  constructor(dims: DataSourceCategoryEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.data_source_category_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.data_source_category_key as DataSourceCategoryKey);
  }
}

// app.company_collateral_type.collateral_type_key
export enum CompanyCollateralTypeKey {
  norwegian_mapping_authority_lien = 'norwegian_mapping_authority^^^lien',
  norwegian_mapping_authority_registered_lien = 'norwegian_mapping_authority^^^registered_lien',
  norwegian_movable_property_register_factoringavtale = 'norwegian_movable_property_register^^^factoringavtale',
  norwegian_movable_property_register_leasingavtale = 'norwegian_movable_property_register^^^leasingavtale',
  norwegian_movable_property_register_pant_i_driftstilbehoer = 'norwegian_movable_property_register^^^pant_i_driftstilbehoer',
  norwegian_movable_property_register_pant_i_fiskeredskaper = 'norwegian_movable_property_register^^^pant_i_fiskeredskaper',
  norwegian_movable_property_register_pant_i_jernbanemateriell = 'norwegian_movable_property_register^^^pant_i_jernbanemateriell',
  norwegian_movable_property_register_pant_i_landbruksnaering = 'norwegian_movable_property_register^^^pant_i_landbruksnaering',
  norwegian_movable_property_register_pant_i_motorvognanleggsmidler = 'norwegian_movable_property_register^^^pant_i_motorvognanleggsmidler',
  norwegian_movable_property_register_pant_i_varelager = 'norwegian_movable_property_register^^^pant_i_varelager',
  norwegian_movable_property_register_pantsettelse_av_akvakulturtillatelser = 'norwegian_movable_property_register^^^pantsettelse_av_akvakulturtillatelser',
  norwegian_movable_property_register_salgspant_i_motorvogn = 'norwegian_movable_property_register^^^salgspant_i_motorvogn',
  norwegian_ship_register_ship_mortgage = 'norwegian_ship_register^^^ship_mortgage',
}

// app.company_collateral_type.collateral_type_key
export class CompanyCollateralTypeDims implements DimContainer<CompanyCollateralTypeKey>, DimFlagContainer {
  public flags:
    | {
        norwegian_mapping_authority_lien: boolean;
        norwegian_mapping_authority_registered_lien: boolean;
        norwegian_movable_property_register_factoringavtale: boolean;
        norwegian_movable_property_register_leasingavtale: boolean;
        norwegian_movable_property_register_pant_i_driftstilbehoer: boolean;
        norwegian_movable_property_register_pant_i_fiskeredskaper: boolean;
        norwegian_movable_property_register_pant_i_jernbanemateriell: boolean;
        norwegian_movable_property_register_pant_i_landbruksnaering: boolean;
        norwegian_movable_property_register_pant_i_motorvognanleggsmidler: boolean;
        norwegian_movable_property_register_pant_i_varelager: boolean;
        norwegian_movable_property_register_pantsettelse_av_akvakulturtillatelser: boolean;
        norwegian_movable_property_register_salgspant_i_motorvogn: boolean;
        norwegian_ship_register_ship_mortgage: boolean;
      }
    | Dict<boolean>;
  public dims: CompanyCollateralTypeEntity[];
  public keys: CompanyCollateralTypeKey[];

  constructor(dims: CompanyCollateralTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.collateral_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.collateral_type_key as CompanyCollateralTypeKey);
  }
}

// app.company_flag_type.company_flag_type_key
export enum CompanyFlagTypeKey {
  accounts_not_announced_before_deadline = 'accounts_not_announced_before_deadline',
  accounts_recently_available = 'accounts_recently_available',
  any_direct_ownership_change_norwegian_share_registry = 'any_direct_ownership_change_norwegian_share_registry',
  auditor_change_after_accounts_with_auditor_note = 'auditor_change_after_accounts_with_auditor_note',
  auditor_note_significant_uncertainty_about_continued_operation = 'auditor_note_significant_uncertainty_about_continued_operation',
  auditor_note_uncertainty_about_continued_operation = 'auditor_note_uncertainty_about_continued_operation',
  auditor_resigned = 'auditor_resigned',
  auditor_resigned_after_accounts_with_auditor_note = 'auditor_resigned_after_accounts_with_auditor_note',
  authorization_arbeidstilsynet_asbestvirksomhet = 'authorization_arbeidstilsynet_asbestvirksomhet',
  authorization_arbeidstilsynet_bedriftshelsetjeneste = 'authorization_arbeidstilsynet_bedriftshelsetjeneste',
  authorization_arbeidstilsynet_bemanningsforetak = 'authorization_arbeidstilsynet_bemanningsforetak',
  authorization_arbeidstilsynet_godkjent_bilvask_dekkskift_dekkhotell = 'authorization_arbeidstilsynet_godkjent_bilvask_dekkskift_dekkhotell',
  authorization_arbeidstilsynet_renholdsregisteret = 'authorization_arbeidstilsynet_renholdsregisteret',
  authorization_innsamlingskontrollen = 'authorization_innsamlingskontrollen',
  authorization_sentral_godkjenning = 'authorization_sentral_godkjenning',
  authorization_vegvesen_godkjent_verksted = 'authorization_vegvesen_godkjent_verksted',
  authorization_vegvesen_transportorregister = 'authorization_vegvesen_transportorregister',
  bankruptcy_defendant = 'bankruptcy_defendant',
  bankruptcy_prone = 'bankruptcy_prone',
  beneficial_ownership_change = 'beneficial_ownership_change',
  beneficial_ownership_change_or_new_beneficial_owners = 'beneficial_ownership_change_or_new_beneficial_owners',
  board_chairman_previous_bankruptcy = 'board_chairman_previous_bankruptcy',
  ceo_previous_bankruptcy = 'ceo_previous_bankruptcy',
  company_requires_an_auditor = 'company_requires_an_auditor',
  company_restarted_employment_after_interruption = 'company_restarted_employment_after_interruption',
  company_setup_change_major = 'company_setup_change_major',
  complete_change_in_company_leadership = 'complete_change_in_company_leadership',
  complete_ownership_change_direct_ownership_previous_year = 'complete_ownership_change_direct_ownership_previous_year',
  complete_ownership_change_ultimate_ownership_previous_year = 'complete_ownership_change_ultimate_ownership_previous_year',
  confirmed_dead = 'confirmed_dead',
  deleted_after_demerger = 'deleted_after_demerger',
  deleted_after_merger = 'deleted_after_merger',
  downsizing = 'downsizing',
  downsizing_employee_dismissal = 'downsizing_employee_dismissal',
  employee_litigation = 'employee_litigation',
  fsa_license_administrator_etter_referanserenteloven = 'fsa_license_administrator_etter_referanserenteloven',
  fsa_license_administrator_etter_referanseverdiloven = 'fsa_license_administrator_etter_referanseverdiloven',
  fsa_license_agent_for_norske_betalingsforetak_foretak = 'fsa_license_agent_for_norske_betalingsforetak_foretak',
  fsa_license_aksessorisk_forsikringsagentvirksomhet = 'fsa_license_aksessorisk_forsikringsagentvirksomhet',
  fsa_license_alternativt_investeringsfond_aif = 'fsa_license_alternativt_investeringsfond_aif',
  fsa_license_bank = 'fsa_license_bank',
  fsa_license_betalingsforetak = 'fsa_license_betalingsforetak',
  fsa_license_betalingsforetak_med_begrenset_tillatelse = 'fsa_license_betalingsforetak_med_begrenset_tillatelse',
  fsa_license_betalingstjenestevirksomhet_unntatt_konsesjonsplikt = 'fsa_license_betalingstjenestevirksomhet_unntatt_konsesjonsplikt',
  fsa_license_deltakere = 'fsa_license_deltakere',
  fsa_license_depotmottaker = 'fsa_license_depotmottaker',
  fsa_license_eiendomsmeglingsforetak = 'fsa_license_eiendomsmeglingsforetak',
  fsa_license_epengeforetak = 'fsa_license_epengeforetak',
  fsa_license_er_agent_for = 'fsa_license_er_agent_for',
  fsa_license_er_deltaker_i = 'fsa_license_er_deltaker_i',
  fsa_license_er_depotmottaker_for = 'fsa_license_er_depotmottaker_for',
  fsa_license_er_fondsforvalter_for = 'fsa_license_er_fondsforvalter_for',
  fsa_license_filial_av_utenlandsk_fremmedinkassoforetak_nuf = 'fsa_license_filial_av_utenlandsk_fremmedinkassoforetak_nuf',
  fsa_license_filial_av_utenlandsk_regnskapsfrerselskap_nuf = 'fsa_license_filial_av_utenlandsk_regnskapsfrerselskap_nuf',
  fsa_license_filial_av_utenlandsk_regnskapsselskap_nuf = 'fsa_license_filial_av_utenlandsk_regnskapsselskap_nuf',
  fsa_license_filial_av_utenl_forvaltningsselskap_nuf__vpfond = 'fsa_license_filial_av_utenl_forvaltningsselskap_nuf__vpfond',
  fsa_license_filial_av_utenl_kredittinstitusjon_nuf = 'fsa_license_filial_av_utenl_kredittinstitusjon_nuf',
  fsa_license_filial_av_utenl_livsforsikringsselskap_nuf = 'fsa_license_filial_av_utenl_livsforsikringsselskap_nuf',
  fsa_license_filial_av_utenl_skadeforsikringsselskap_nuf = 'fsa_license_filial_av_utenl_skadeforsikringsselskap_nuf',
  fsa_license_filial_av_utenl_verdipapirforetak_nuf = 'fsa_license_filial_av_utenl_verdipapirforetak_nuf',
  fsa_license_finansieringsforetak = 'fsa_license_finansieringsforetak',
  fsa_license_finansstiftelse = 'fsa_license_finansstiftelse',
  fsa_license_forsikringsagentforetak = 'fsa_license_forsikringsagentforetak',
  fsa_license_forsikringsagentregistre = 'fsa_license_forsikringsagentregistre',
  fsa_license_forsikringsmeglingsforetak = 'fsa_license_forsikringsmeglingsforetak',
  fsa_license_forvalter_av_alternative_investeringsfond = 'fsa_license_forvalter_av_alternative_investeringsfond',
  fsa_license_forvalter_av_alternative_investeringsfond_aifm = 'fsa_license_forvalter_av_alternative_investeringsfond_aifm',
  fsa_license_forvalter_nominee_i_norske_eierregistre = 'fsa_license_forvalter_nominee_i_norske_eierregistre',
  fsa_license_forvaltningsselskap_for_verdipapirfond = 'fsa_license_forvaltningsselskap_for_verdipapirfond',
  fsa_license_fremmedinkassoforetak = 'fsa_license_fremmedinkassoforetak',
  fsa_license_gjeldsinformasjonsforetak = 'fsa_license_gjeldsinformasjonsforetak',
  fsa_license_gjenforsikringsmeglingsforetak = 'fsa_license_gjenforsikringsmeglingsforetak',
  fsa_license_grensekr_inn_fra_annet_esland_mifid_art_ = 'fsa_license_grensekr_inn_fra_annet_esland_mifid_art_',
  fsa_license_holdingforetak = 'fsa_license_holdingforetak',
  fsa_license_infrastrukturforetak = 'fsa_license_infrastrukturforetak',
  fsa_license_innskuddspensjonsforetak = 'fsa_license_innskuddspensjonsforetak',
  fsa_license_kommunal_pensjonskasse_mv = 'fsa_license_kommunal_pensjonskasse_mv',
  fsa_license_kredittforetak = 'fsa_license_kredittforetak',
  fsa_license_kryptoeiendelstjenestetilbydere_casp = 'fsa_license_kryptoeiendelstjenestetilbydere_casp',
  fsa_license_livsforsikringsforetak = 'fsa_license_livsforsikringsforetak',
  fsa_license_lneformidling = 'fsa_license_lneformidling',
  fsa_license_markedsoperatr = 'fsa_license_markedsoperatr',
  fsa_license_naturskadeforsikring = 'fsa_license_naturskadeforsikring',
  fsa_license_operatr_for_verdipapiroppgjrsystem = 'fsa_license_operatr_for_verdipapiroppgjrsystem',
  fsa_license_oppkjpsegeninkassoforetak = 'fsa_license_oppkjpsegeninkassoforetak',
  fsa_license_opplysningsfullmektig = 'fsa_license_opplysningsfullmektig',
  fsa_license_pensjonsfond = 'fsa_license_pensjonsfond',
  fsa_license_privat_pensjonskasse = 'fsa_license_privat_pensjonskasse',
  fsa_license_registrert_aifforvalter = 'fsa_license_registrert_aifforvalter',
  fsa_license_registrert_lne_og_garantiformidler = 'fsa_license_registrert_lne_og_garantiformidler',
  fsa_license_regnskapsfrerselskap = 'fsa_license_regnskapsfrerselskap',
  fsa_license_regnskapsselskap = 'fsa_license_regnskapsselskap',
  fsa_license_revisjonsselskap = 'fsa_license_revisjonsselskap',
  fsa_license_sjtrygdelag = 'fsa_license_sjtrygdelag',
  fsa_license_skadeforsikringsforetak = 'fsa_license_skadeforsikringsforetak',
  fsa_license_sparebankstiftelse = 'fsa_license_sparebankstiftelse',
  fsa_license_systematisk_internaliserer = 'fsa_license_systematisk_internaliserer',
  fsa_license_tilbyder_av_virksomhetstjenester = 'fsa_license_tilbyder_av_virksomhetstjenester',
  fsa_license_tilknyttet_agent__foretak_verdipapiromrdet = 'fsa_license_tilknyttet_agent__foretak_verdipapiromrdet',
  fsa_license_tredjelandsrevisor = 'fsa_license_tredjelandsrevisor',
  fsa_license_vekslings_og_oppbevaringstjenester_for_virtuell_valuta = 'fsa_license_vekslings_og_oppbevaringstjenester_for_virtuell_valuta',
  fsa_license_verdipapirfond = 'fsa_license_verdipapirfond',
  fsa_license_verdipapirforetak = 'fsa_license_verdipapirforetak',
  fsa_license_verdipapirsentral = 'fsa_license_verdipapirsentral',
  has_auditor_note = 'has_auditor_note',
  has_collateral = 'has_collateral',
  high_credit_risk_event = 'high_credit_risk_event',
  in_court = 'in_court',
  indicator_accounts_registered_early = 'indicator_accounts_registered_early',
  indicator_accounts_registered_very_early = 'indicator_accounts_registered_very_early',
  indicator_company_business_and_postal_address_distant = 'indicator_company_business_and_postal_address_distant',
  indicator_company_has_auditor = 'indicator_company_has_auditor',
  indicator_company_has_doubled_revenue_per_employee_last_years = 'indicator_company_has_doubled_revenue_per_employee_last_years',
  indicator_company_has_major_assets = 'indicator_company_has_major_assets',
  indicator_company_has_more_cars_than_employees = 'indicator_company_has_more_cars_than_employees',
  indicator_company_has_no_registered_accountant = 'indicator_company_has_no_registered_accountant',
  indicator_company_has_no_registered_auditor = 'indicator_company_has_no_registered_auditor',
  indicator_company_has_possible_errors_in_last_available_company_accounts = 'indicator_company_has_possible_errors_in_last_available_company_accounts',
  indicator_company_has_possible_errors_in_recent_company_accounts = 'indicator_company_has_possible_errors_in_recent_company_accounts',
  indicator_company_has_recently_increased_amount_of_car_collateral = 'indicator_company_has_recently_increased_amount_of_car_collateral',
  indicator_company_has_significant_assets = 'indicator_company_has_significant_assets',
  indicator_company_has_wage_expenses_but_no_employees = 'indicator_company_has_wage_expenses_but_no_employees',
  indicator_company_moved_postal_address = 'indicator_company_moved_postal_address',
  indicator_company_owns_property = 'indicator_company_owns_property',
  indicator_company_shares_name_with_bankrupt_company = 'indicator_company_shares_name_with_bankrupt_company',
  indicator_company_with_residential_address = 'indicator_company_with_residential_address',
  indicator_high_role_change_velocity = 'indicator_high_role_change_velocity',
  indicator_income_right_under_auditor_limit = 'indicator_income_right_under_auditor_limit',
  indicator_large_increase_in_revenues = 'indicator_large_increase_in_revenues',
  indicator_large_increase_in_revenues_compared_to_last_two_years = 'indicator_large_increase_in_revenues_compared_to_last_two_years',
  indicator_old_roles_in_company = 'indicator_old_roles_in_company',
  indicator_only_fresh_persons_active_roles_in_company = 'indicator_only_fresh_persons_active_roles_in_company',
  indicator_only_one_person_active_role_in_company = 'indicator_only_one_person_active_role_in_company',
  indicator_very_large_increase_in_revenues = 'indicator_very_large_increase_in_revenues',
  is_vat_registered = 'is_vat_registered',
  litigation_defendant = 'litigation_defendant',
  mesterbedrift = 'mesterbedrift',
  negative_total_equity = 'negative_total_equity',
  owned_a_ship = 'owned_a_ship',
  owns_a_ship = 'owns_a_ship',
  part_of_corporate_group = 'part_of_corporate_group',
  person_in_company_in_bankruptcy_quarantine = 'person_in_company_in_bankruptcy_quarantine',
  person_in_company_involved_in_previous_bankruptcy = 'person_in_company_involved_in_previous_bankruptcy',
  person_in_company_previous_bankruptcy = 'person_in_company_previous_bankruptcy',
  possible_change_ownership = 'possible_change_ownership',
  possible_ownership_change_owners_with_roles_exited_company = 'possible_ownership_change_owners_with_roles_exited_company',
  recent_bankruptcy_in_corporate_group = 'recent_bankruptcy_in_corporate_group',
  recent_change_of_nace_code = 'recent_change_of_nace_code',
  recent_high_risk_event = 'recent_high_risk_event',
  registered_bankrupt = 'registered_bankrupt',
  registered_forced_liquidation = 'registered_forced_liquidation',
  registered_liquidation = 'registered_liquidation',
  replaced_unaudited_accounts = 'replaced_unaudited_accounts',
  replaced_unaudited_accounts_with_significant_changes = 'replaced_unaudited_accounts_with_significant_changes',
  reversed_liquidation = 'reversed_liquidation',
  same_person_is_ceo_and_board_chairman = 'same_person_is_ceo_and_board_chairman',
  same_person_owns_more_than_half_and_is_board_chairman = 'same_person_owns_more_than_half_and_is_board_chairman',
  same_person_owns_more_than_half_and_is_ceo_and_board_chairman = 'same_person_owns_more_than_half_and_is_ceo_and_board_chairman',
  temporary_crisis_flag_corona_article = 'temporary_crisis_flag_corona_article',
  temporary_crisis_flag_given_compensation = 'temporary_crisis_flag_given_compensation',
  temporary_crisis_flag_temporary_layoffs = 'temporary_crisis_flag_temporary_layoffs',
  under_reconstruction = 'under_reconstruction',
  warning_list_arbeidstilsynet_not_authorized = 'warning_list_arbeidstilsynet_not_authorized',
  warning_list_innsamlingskontrollen_obs_listen = 'warning_list_innsamlingskontrollen_obs_listen',
}

// app.company_flag_type.company_flag_type_key
export class CompanyFlagTypeDims implements DimContainer<CompanyFlagTypeKey>, DimFlagContainer {
  public flags:
    | {
        accounts_not_announced_before_deadline: boolean;
        accounts_recently_available: boolean;
        any_direct_ownership_change_norwegian_share_registry: boolean;
        auditor_change_after_accounts_with_auditor_note: boolean;
        auditor_note_significant_uncertainty_about_continued_operation: boolean;
        auditor_note_uncertainty_about_continued_operation: boolean;
        auditor_resigned: boolean;
        auditor_resigned_after_accounts_with_auditor_note: boolean;
        authorization_arbeidstilsynet_asbestvirksomhet: boolean;
        authorization_arbeidstilsynet_bedriftshelsetjeneste: boolean;
        authorization_arbeidstilsynet_bemanningsforetak: boolean;
        authorization_arbeidstilsynet_godkjent_bilvask_dekkskift_dekkhotell: boolean;
        authorization_arbeidstilsynet_renholdsregisteret: boolean;
        authorization_innsamlingskontrollen: boolean;
        authorization_sentral_godkjenning: boolean;
        authorization_vegvesen_godkjent_verksted: boolean;
        authorization_vegvesen_transportorregister: boolean;
        bankruptcy_defendant: boolean;
        bankruptcy_prone: boolean;
        beneficial_ownership_change: boolean;
        beneficial_ownership_change_or_new_beneficial_owners: boolean;
        board_chairman_previous_bankruptcy: boolean;
        ceo_previous_bankruptcy: boolean;
        company_requires_an_auditor: boolean;
        company_restarted_employment_after_interruption: boolean;
        company_setup_change_major: boolean;
        complete_change_in_company_leadership: boolean;
        complete_ownership_change_direct_ownership_previous_year: boolean;
        complete_ownership_change_ultimate_ownership_previous_year: boolean;
        confirmed_dead: boolean;
        deleted_after_demerger: boolean;
        deleted_after_merger: boolean;
        downsizing: boolean;
        downsizing_employee_dismissal: boolean;
        employee_litigation: boolean;
        fsa_license_administrator_etter_referanserenteloven: boolean;
        fsa_license_administrator_etter_referanseverdiloven: boolean;
        fsa_license_agent_for_norske_betalingsforetak_foretak: boolean;
        fsa_license_aksessorisk_forsikringsagentvirksomhet: boolean;
        fsa_license_alternativt_investeringsfond_aif: boolean;
        fsa_license_bank: boolean;
        fsa_license_betalingsforetak: boolean;
        fsa_license_betalingsforetak_med_begrenset_tillatelse: boolean;
        fsa_license_betalingstjenestevirksomhet_unntatt_konsesjonsplikt: boolean;
        fsa_license_deltakere: boolean;
        fsa_license_depotmottaker: boolean;
        fsa_license_eiendomsmeglingsforetak: boolean;
        fsa_license_epengeforetak: boolean;
        fsa_license_er_agent_for: boolean;
        fsa_license_er_deltaker_i: boolean;
        fsa_license_er_depotmottaker_for: boolean;
        fsa_license_er_fondsforvalter_for: boolean;
        fsa_license_filial_av_utenlandsk_fremmedinkassoforetak_nuf: boolean;
        fsa_license_filial_av_utenlandsk_regnskapsfrerselskap_nuf: boolean;
        fsa_license_filial_av_utenlandsk_regnskapsselskap_nuf: boolean;
        fsa_license_filial_av_utenl_forvaltningsselskap_nuf__vpfond: boolean;
        fsa_license_filial_av_utenl_kredittinstitusjon_nuf: boolean;
        fsa_license_filial_av_utenl_livsforsikringsselskap_nuf: boolean;
        fsa_license_filial_av_utenl_skadeforsikringsselskap_nuf: boolean;
        fsa_license_filial_av_utenl_verdipapirforetak_nuf: boolean;
        fsa_license_finansieringsforetak: boolean;
        fsa_license_finansstiftelse: boolean;
        fsa_license_forsikringsagentforetak: boolean;
        fsa_license_forsikringsagentregistre: boolean;
        fsa_license_forsikringsmeglingsforetak: boolean;
        fsa_license_forvalter_av_alternative_investeringsfond: boolean;
        fsa_license_forvalter_av_alternative_investeringsfond_aifm: boolean;
        fsa_license_forvalter_nominee_i_norske_eierregistre: boolean;
        fsa_license_forvaltningsselskap_for_verdipapirfond: boolean;
        fsa_license_fremmedinkassoforetak: boolean;
        fsa_license_gjeldsinformasjonsforetak: boolean;
        fsa_license_gjenforsikringsmeglingsforetak: boolean;
        fsa_license_grensekr_inn_fra_annet_esland_mifid_art_: boolean;
        fsa_license_holdingforetak: boolean;
        fsa_license_infrastrukturforetak: boolean;
        fsa_license_innskuddspensjonsforetak: boolean;
        fsa_license_kommunal_pensjonskasse_mv: boolean;
        fsa_license_kredittforetak: boolean;
        fsa_license_kryptoeiendelstjenestetilbydere_casp: boolean;
        fsa_license_livsforsikringsforetak: boolean;
        fsa_license_lneformidling: boolean;
        fsa_license_markedsoperatr: boolean;
        fsa_license_naturskadeforsikring: boolean;
        fsa_license_operatr_for_verdipapiroppgjrsystem: boolean;
        fsa_license_oppkjpsegeninkassoforetak: boolean;
        fsa_license_opplysningsfullmektig: boolean;
        fsa_license_pensjonsfond: boolean;
        fsa_license_privat_pensjonskasse: boolean;
        fsa_license_registrert_aifforvalter: boolean;
        fsa_license_registrert_lne_og_garantiformidler: boolean;
        fsa_license_regnskapsfrerselskap: boolean;
        fsa_license_regnskapsselskap: boolean;
        fsa_license_revisjonsselskap: boolean;
        fsa_license_sjtrygdelag: boolean;
        fsa_license_skadeforsikringsforetak: boolean;
        fsa_license_sparebankstiftelse: boolean;
        fsa_license_systematisk_internaliserer: boolean;
        fsa_license_tilbyder_av_virksomhetstjenester: boolean;
        fsa_license_tilknyttet_agent__foretak_verdipapiromrdet: boolean;
        fsa_license_tredjelandsrevisor: boolean;
        fsa_license_vekslings_og_oppbevaringstjenester_for_virtuell_valuta: boolean;
        fsa_license_verdipapirfond: boolean;
        fsa_license_verdipapirforetak: boolean;
        fsa_license_verdipapirsentral: boolean;
        has_auditor_note: boolean;
        has_collateral: boolean;
        high_credit_risk_event: boolean;
        in_court: boolean;
        indicator_accounts_registered_early: boolean;
        indicator_accounts_registered_very_early: boolean;
        indicator_company_business_and_postal_address_distant: boolean;
        indicator_company_has_auditor: boolean;
        indicator_company_has_doubled_revenue_per_employee_last_years: boolean;
        indicator_company_has_major_assets: boolean;
        indicator_company_has_more_cars_than_employees: boolean;
        indicator_company_has_no_registered_accountant: boolean;
        indicator_company_has_no_registered_auditor: boolean;
        indicator_company_has_possible_errors_in_last_available_company_accounts: boolean;
        indicator_company_has_possible_errors_in_recent_company_accounts: boolean;
        indicator_company_has_recently_increased_amount_of_car_collateral: boolean;
        indicator_company_has_significant_assets: boolean;
        indicator_company_has_wage_expenses_but_no_employees: boolean;
        indicator_company_moved_postal_address: boolean;
        indicator_company_owns_property: boolean;
        indicator_company_shares_name_with_bankrupt_company: boolean;
        indicator_company_with_residential_address: boolean;
        indicator_high_role_change_velocity: boolean;
        indicator_income_right_under_auditor_limit: boolean;
        indicator_large_increase_in_revenues: boolean;
        indicator_large_increase_in_revenues_compared_to_last_two_years: boolean;
        indicator_old_roles_in_company: boolean;
        indicator_only_fresh_persons_active_roles_in_company: boolean;
        indicator_only_one_person_active_role_in_company: boolean;
        indicator_very_large_increase_in_revenues: boolean;
        is_vat_registered: boolean;
        litigation_defendant: boolean;
        mesterbedrift: boolean;
        negative_total_equity: boolean;
        owned_a_ship: boolean;
        owns_a_ship: boolean;
        part_of_corporate_group: boolean;
        person_in_company_in_bankruptcy_quarantine: boolean;
        person_in_company_involved_in_previous_bankruptcy: boolean;
        person_in_company_previous_bankruptcy: boolean;
        possible_change_ownership: boolean;
        possible_ownership_change_owners_with_roles_exited_company: boolean;
        recent_bankruptcy_in_corporate_group: boolean;
        recent_change_of_nace_code: boolean;
        recent_high_risk_event: boolean;
        registered_bankrupt: boolean;
        registered_forced_liquidation: boolean;
        registered_liquidation: boolean;
        replaced_unaudited_accounts: boolean;
        replaced_unaudited_accounts_with_significant_changes: boolean;
        reversed_liquidation: boolean;
        same_person_is_ceo_and_board_chairman: boolean;
        same_person_owns_more_than_half_and_is_board_chairman: boolean;
        same_person_owns_more_than_half_and_is_ceo_and_board_chairman: boolean;
        temporary_crisis_flag_corona_article: boolean;
        temporary_crisis_flag_given_compensation: boolean;
        temporary_crisis_flag_temporary_layoffs: boolean;
        under_reconstruction: boolean;
        warning_list_arbeidstilsynet_not_authorized: boolean;
        warning_list_innsamlingskontrollen_obs_listen: boolean;
      }
    | Dict<boolean>;
  public dims: CompanyFlagTypeEntity[];
  public keys: CompanyFlagTypeKey[];

  constructor(dims: CompanyFlagTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.company_flag_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.company_flag_type_key as CompanyFlagTypeKey);
  }
}

// app.company_measure_type.company_measure_type_key
export enum CompanyMeasureTypeKey {
  company_accounts_cash_to_revenue_ratio = 'company_accounts_cash_to_revenue_ratio',
  company_accounts_cogs_to_revenue_ratio = 'company_accounts_cogs_to_revenue_ratio',
  company_accounts_current_ratio = 'company_accounts_current_ratio',
  company_accounts_current_ratio_per_employee = 'company_accounts_current_ratio_per_employee',
  company_accounts_days_of_inventory = 'company_accounts_days_of_inventory',
  company_accounts_days_payable_outstanding = 'company_accounts_days_payable_outstanding',
  company_accounts_days_sales_outstanding = 'company_accounts_days_sales_outstanding',
  company_accounts_depreciation_to_fixed_assets_ratio = 'company_accounts_depreciation_to_fixed_assets_ratio',
  company_accounts_ebitda = 'company_accounts_ebitda',
  company_accounts_ebitda_per_employee = 'company_accounts_ebitda_per_employee',
  company_accounts_equity_profitability = 'company_accounts_equity_profitability',
  company_accounts_equity_profitability_per_employee = 'company_accounts_equity_profitability_per_employee',
  company_accounts_gross_margin_ratio = 'company_accounts_gross_margin_ratio',
  company_accounts_inventory_to_cogs_ratio = 'company_accounts_inventory_to_cogs_ratio',
  company_accounts_net_income = 'company_accounts_net_income',
  company_accounts_net_income_per_employee = 'company_accounts_net_income_per_employee',
  company_accounts_net_profit_margin = 'company_accounts_net_profit_margin',
  company_accounts_net_profit_margin_per_employee = 'company_accounts_net_profit_margin_per_employee',
  company_accounts_operating_profit = 'company_accounts_operating_profit',
  company_accounts_operating_profit_per_employee = 'company_accounts_operating_profit_per_employee',
  company_accounts_operating_revenue = 'company_accounts_operating_revenue',
  company_accounts_operating_revenue_per_employee = 'company_accounts_operating_revenue_per_employee',
  company_accounts_personnel_cost_to_revenue_ratio = 'company_accounts_personnel_cost_to_revenue_ratio',
  company_accounts_profit_margin = 'company_accounts_profit_margin',
  company_accounts_profit_margin_per_employee = 'company_accounts_profit_margin_per_employee',
  company_accounts_revenue_per_employee = 'company_accounts_revenue_per_employee',
  company_accounts_soft_assets_ratio = 'company_accounts_soft_assets_ratio',
  company_accounts_wage_cost = 'company_accounts_wage_cost',
  company_accounts_wage_cost_per_employee = 'company_accounts_wage_cost_per_employee',
  registered_employee_count_average = 'registered_employee_count_average',
}

// app.company_measure_type.company_measure_type_key
export class CompanyMeasureTypeDims implements DimContainer<CompanyMeasureTypeKey>, DimFlagContainer {
  public flags:
    | {
        company_accounts_cash_to_revenue_ratio: boolean;
        company_accounts_cogs_to_revenue_ratio: boolean;
        company_accounts_current_ratio: boolean;
        company_accounts_current_ratio_per_employee: boolean;
        company_accounts_days_of_inventory: boolean;
        company_accounts_days_payable_outstanding: boolean;
        company_accounts_days_sales_outstanding: boolean;
        company_accounts_depreciation_to_fixed_assets_ratio: boolean;
        company_accounts_ebitda: boolean;
        company_accounts_ebitda_per_employee: boolean;
        company_accounts_equity_profitability: boolean;
        company_accounts_equity_profitability_per_employee: boolean;
        company_accounts_gross_margin_ratio: boolean;
        company_accounts_inventory_to_cogs_ratio: boolean;
        company_accounts_net_income: boolean;
        company_accounts_net_income_per_employee: boolean;
        company_accounts_net_profit_margin: boolean;
        company_accounts_net_profit_margin_per_employee: boolean;
        company_accounts_operating_profit: boolean;
        company_accounts_operating_profit_per_employee: boolean;
        company_accounts_operating_revenue: boolean;
        company_accounts_operating_revenue_per_employee: boolean;
        company_accounts_personnel_cost_to_revenue_ratio: boolean;
        company_accounts_profit_margin: boolean;
        company_accounts_profit_margin_per_employee: boolean;
        company_accounts_revenue_per_employee: boolean;
        company_accounts_soft_assets_ratio: boolean;
        company_accounts_wage_cost: boolean;
        company_accounts_wage_cost_per_employee: boolean;
        registered_employee_count_average: boolean;
      }
    | Dict<boolean>;
  public dims: CompanyMeasureTypeEntity[];
  public keys: CompanyMeasureTypeKey[];

  constructor(dims: CompanyMeasureTypeEntity[] = []) {
    this.flags = arrayToPickyDict(
      dims,
      (d) => d.company_measure_type_key,
      (d) => true,
    );
    this.dims = dims;
    this.keys = dims.map((d) => d.company_measure_type_key as CompanyMeasureTypeKey);
  }
}
